import store from 'redux/store'

const storeMixin = {
  init: function () {
    this.store = store
  }
}
riot.mixin('store', storeMixin)